module.exports = __webpack_public_path__ + "static/img/NP.4dfbb6ac.png";